export default __webpack_public_path__ + "static/media/Arshad.a6e55dcb.png";